/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { clearSubscription } from '../../Utilities/subscription-manager';
import { IResetSubscriptionData } from './reset-subscription.data';
import { IResetSubscriptionProps } from './reset-subscription.props.autogenerated';

/**
 *
 * ResetSubscription component
 * @extends {React.PureComponent<IResetSubscriptionProps<IResetSubscriptionData>>}
 */
class ResetSubscription extends React.PureComponent<IResetSubscriptionProps<IResetSubscriptionData>> {

    private _didClearSubscription: boolean = false;

    public render(): JSX.Element | null {
        if (!this._didClearSubscription && this.props.data.cart.result) {
            clearSubscription(this.props.data.cart.result, this.props.context)
                .then(() => this.props.telemetry.debug('[ResetSubscription] cleared subscription cart'))
                .catch((e) => this.props.telemetry.error('[ResetSubscription] failed to clear subscription cart', e));
            this._didClearSubscription = true;
        }
        return <div />;
    }
}

export default ResetSubscription;
